import { useState, useEffect, useRef } from "react"
import { Flex, Input, Modal, Form, Dropdown, List, Button } from "antd"
import { useTranslation } from "react-i18next"
import { useUser } from "../contexts/UserContext"
import { getOrganizations, getResellers, removeOrganization, removeAccount } from "../api/Cards/users"
import { message } from "../../node_modules/antd/es/index"
import { NavLink, useNavigate } from "react-router-dom"

const AccountEditorModal = ({ onClose, selectedAccount, isOrg, messageApi }) => {

    const handleCancel = () => onClose();
    const { t } = useTranslation()
    const { user, getToken } = useUser()
    const [showModal, setShowModal] = useState(false)
    const orgItems = useRef([])
    const resellerItems = useRef([])
    const [selectedTarget, setSelectedTarget] = useState(null)
    const navigate = useNavigate()


    /*
        Resellers and Organizations will need to have their sub-accounts moved if deleted
    
    */

    function removeAccountInternal() {

        if (selectedAccount.Role == -1) {   //Organization
            if ((selectedAccount.Children[0].Children != null &&
                selectedAccount.Children[0].Children.length > 0) ||
                (selectedAccount.Children[1].Children != null &&
                    selectedAccount.Children[1].Children.length > 0))
                setShowModal(true)
            else
                removeFinalOrganization();
        }
        else if (selectedAccount.Role == 1 && selectedAccount.Children != null && selectedAccount.Children.length > 0) {
            //Reseller
            setShowModal(true)
        }
        else
            removeFinalAccount();

    }

    function removeFinalAccount() {

        async function doRemoveAccount() {
            const data = await removeAccount({ Token: user.token, UserID: selectedAccount.UserID, TransferID: (selectedTarget ? selectedTarget.Id : 0) })

            if (typeof data == "number") {
                console.log("Server error ", data)
                message.error(t('page.acceditormodal.error'))
                return
            }

            message.success(t('page.acceditormodal.success'))

            onClose();
        }

        doRemoveAccount();
    }

    function removeFinalOrganization() {

        async function doRemoveOrganization() {
            const data = await removeOrganization({ Token: user.token, UserID: selectedAccount.UserID, TransferID: (selectedTarget ? selectedTarget.Id : 0) })

            if (typeof data == "number") {
                console.log("Server error ", data)
                message.error(t('page.acceditormodal.error'))
                return
            }

            message.success(t('page.acceditormodal.success'))

            onClose();
        }

        doRemoveOrganization();
    }

    async function getOrgs() {
        const data = await getOrganizations(user.token)

        if (typeof data === "number") {
            return null
        }

        orgItems.current = Object.values(data).filter(function (Item) { return Item.OrganizationId != selectedAccount.UserID })
    }
        

    async function getResellerRemote() {
        const data = await getResellers({ Token: user.token, OrganizationId: selectedAccount.OrgID })

        if (typeof data === "number") {
            return null
        }

        resellerItems.current = data.filter(function (Item) { return Item.ResellerId != selectedAccount.UserID })
    }

    function fetchData() {
        if (isOrg)
            getOrgs();
        else
            getResellerRemote();
    }

    useEffect(() => {
        fetchData();
    }, [])
    function getMenuItems() {

        if (selectedAccount.Role == -1) {
            return orgItems.current.map(({ OrganizationName, OrganizationId }, i) => ({ key: i, label: OrganizationName }))

        }
        else {
            return resellerItems.current.map(({ ResellerName, ResellerId }, i) => ({ key: i, label: ResellerName }))
        }

    }

    function getModalTitle() {

        if (isOrg)
            return t('page.acceditormodal.movorg')

        return t('page.acceditormodal.movresell')
    }

    function getModalDesc() {
        if (isOrg)
            return t('page.acceditormodal.orgdesc')

        return t('page.acceditormodal.resdesc');
    }

    function selectItem(e) {
        if (isOrg)
            setSelectedTarget({ Name: orgItems.current[e.key].OrganizationName, Id: orgItems.current[e.key].OrganizationId })
        else
            setSelectedTarget({ Name: resellerItems.current[e.key].ResellerName, Id: resellerItems.current[e.key].ResellerId })
    }

    function processTransfer() {
        if (selectedTarget == null) {
            message.error(t('page.acceditormodal.choice'))
            return;
        }

        if (isOrg)
            removeFinalOrganization();
        else
            removeFinalAccount();

    }


    return (
        <>
            <Modal footer={null} title={(<div>{t("page.accountmanage." + (isOrg? "orgtitle" : "acctitle"))}</div>)} width={'635px'} minHeight={'300px'} onCancel={handleCancel} cancelText="Stäng" open>
                <Flex style={{ justifyContent: "center", flexDirection: "row", flexWrap: "wrap" }}>
                    {!isOrg && (<Button style={{ width: "300px", height: "50px", marginTop: "30px" }} onClick={() => { navigate("/edit-account/" + selectedAccount.UserID) }}>{t('page.accountmanager.modify')}</Button>)}
                    <Button danger style={{ width: "300px", height: "50px", marginTop: "30px" }} onClick={() => { removeAccountInternal() }}>{t('page.acceditormodal.remove')}</Button>
            </Flex>
            </Modal>
            {
                showModal &&
                (<Modal title={getModalTitle()} footer={null} title={(<div>{t('page.acceditormodal.remove')} {isOrg ? "Organisation" : "Konto"}</div>)} width={'635px'} minHeight={'300px'} onCancel={() => setShowModal(false)} cancelText={t('page.acceditormodal.close')} open>
                    <p>{getModalDesc()}</p>
                    <Flex style={{ justifyContent: "center", flexDirection: "row", flexWrap: "wrap" }}>
                        <Dropdown menu={{ items: getMenuItems(), onClick: selectItem }}><Button style={{ marginTop: "50px", width: "100%" }}>{selectedTarget ? selectedTarget.Name : (isOrg ? t('page.acceditormodal.choseorg') : t('page.acceditormodal.choseres'))}</Button></Dropdown>
                        <Button type="primary" onClick={processTransfer} style={{ marginTop: "20px", width: "100%" }}>{t('page.acceditormodal.move')}</Button>
                    </Flex>
                </Modal>)
            }
            
        </>
    )
}

export default AccountEditorModal
